<div class="main-content">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12">
        <span class="pull-left">
          <h2 class="text-purple-manax m-0 pl-3 title-section">Proyectos</h2>
          <!--p class="text-purple-manax pl-3">Listado de Presupuestos</p-->
        </span>
        <!--span class="pull-right pt-1 pb-4 pr-3">
          <button mat-raised-button type="button" class="btn btn-manax p-2 mr-3" (click)="openNewTaskModal()">
            <i class="material-icons">add</i>&nbsp;<span class="d-none d-sm-inline">Nuevo Presupuesto</span>
          </button>
        </span-->
        <span class="pull-right pt-1 pb-4">
          <button mat-raised-button type="button" class="btn btn-manax p-2 mr-1" (click)="openNewProjectsModal()"><!--(click)="openNewQuotesModal()" -->
            <i class="material-icons">add</i>&nbsp;<span class="d-none d-sm-inline">Nuevo</span>
          </button>
        </span>

        <table class="table table-hover m-0 align-top" stickyHeader stickyFooter>

          <thead class="text-manax">
            <tr>

              <!-- All -->
              <!-- <th class="p-0 pl-2">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection()"
                      [checked]="selection.all">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </th> -->

              <!-- PC -->
              <th class="d-none d-md-table-cell align-top" style="width: 200px;">
                Nº<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.number"
                (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()" placeholder="Buscar por Numero…"
                (keydown.space)="$event.stopPropagation()" style="max-width: 1000px;" />
              </th>
              <th class="d-none d-md-table-cell align-top">
                Cliente<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.client"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()" placeholder="Buscar por Cliente…"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 1000px;" />
              </th>
              <!-- <th class="align-top text-center" style="height: 65px; position: relative; max-width: 1000px;">
                Estado<br> <br>
              </th> -->
              <th class="d-none d-md-table-cell align-top">
                Nombre<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.name"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()" placeholder="Buscar por Nombre…"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 1000px;" />
              </th>
              <th class="d-none d-md-table-cell align-top">
                Fecha Inicio<br>
              </th>
              <th class="d-none d-md-table-cell align-top">
                Fecha Fin<br>
              </th>

              <!-- All -->
              <th class="td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>


              </th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let project of projects" [class.text-danger]="project?.isDeleted" class='cursor-pointer'
              (click)="openProjectDetailModal(project)">

              <!-- All -->
              <!-- <td class="p-0 pl-2" (click)="$event.stopPropagation();">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection(quote._id)"
                      [checked]="selection.all || selection[quote._id]">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </td> -->

              <!-- PC -->
              <td class="d-none d-md-table-cell">{{project.serieAndNumber ?? ' - ' }}</td>
              <td class="d-none d-md-table-cell bold-item">{{project.client?.firstname}} {{project.client?.lastname}}</td>
              <!-- <td class="d-none d-md-table-cell p-1">
                <div class="text-center py-1 status-pill text-white"
                  [ngStyle]="{'background-color': projectStatusColors[project?.status]}">
                  {{ projectStatuses[project?.status] }}
                </div>
              </td> -->
              <td class="d-none d-md-table-cell bold-item">{{project?.name}}</td>
              <td class="d-none d-md-table-cell">{{ project.startDate ? (project.startDate | date:'dd/MM/yyyy':'UTC') : ' - ' }}</td>
              <td class="d-none d-md-table-cell">{{ project.endDate ? (project.endDate | date:'dd/MM/yyyy':'UTC') : ' - ' }}</td>
              <!-- Mobile -->
              <td class="d-table-cell d-md-none" style="line-height: 14px;">
                <div class="col-12">
                  <div class="row">
                    <div class="col-8 col-sm-6">
                      <div class="row mb-2 pr-3">
                        <b class="bold-item">
                          N°: {{project.serieAndNumber ?? ' - ' }}
                        </b>
                      </div>
                      <div class="row mb-2 pr-3">
                        {{project.client.firstname}} {{project.client.lastname}}
                      </div>
                      <div class="row mb-2 pr-3">
                        Inicio: {{ project.startDate ? (project.startDate | date:'dd/MM/yyyy':'UTC') : ' - ' }}
                      </div>
                      <div class="row pr-3">
                        Fin: {{ project.endDate ? (project.endDate | date:'dd/MM/yyyy':'UTC') : ' - ' }}
                      </div>
                    </div>
                    <div class="col-4 col-sm-6 d-flex flex-column align-items-center justify-content-center p-0">
                      <!-- <div class="row">
                        <div class="text-center py-1 status-pill text-white"
                          style="border-radius: 15px; font-weight: 600; padding: 5px 5px; color: white; font-size: 13px;"
                          [ngStyle]="{'background-color': projectStatusColors[project?.status]}">
                          {{ projectStatuses[project?.status] }}
                        </div>
                      </div> -->
                    </div>
                  </div>
                </div>
              </td>

              <!-- All -->
              <td class="td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="openProjectsModal(project)">
                    <span>Modificar</span>
                  </button>
                  <!--<button mat-menu-item (click)="openQuote(project)">
                    <span>Abrir PDF</span>
                  </button>
                  <button mat-menu-item (click)="download(project)">
                    <span>Descargar</span>
                  </button>
                  <button mat-menu-item (click)="sendEmail(project)">
                    <span>Enviar por email</span>
                  </button>
                  <button mat-menu-item (click)="openDeleteQuoteConfirm(project)"
                    *ngIf="project?.status == 'QUOTED' && !project.isDeleted">
                    <span>Eliminar</span>
                  </button>
                  <button mat-menu-item (click)="openRestoreQuoteConfirm(project)" *ngIf="project.isDeleted">
                    <span>Restaurar</span>
                  </button> -->
                </mat-menu>
              </td>
            </tr>

            <!-- All  -->
            <tr *ngIf="thereAreMore && !loading">
              <td colspan="10">
                <button class="btn btn-link text-purple-manax text-capitalize p-0" (click)='loadMore()'>+ cargar
                  mas</button>
              </td>
            </tr>

            <tr *ngIf="loading">
              <td colspan="10" class="text-center">
                <div class="d-flex justify-content-center">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>

          </tbody>
          <tfoot class="text-purple-manax">
            <tr *ngIf="!loading">
              <td colspan="10" class="text-left p-0 py-2 pl-3">Mostrando: {{ projects?.length }} proyectos</td>
            </tr>
          </tfoot>
        </table>
        <!-- </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>